module.exports = __webpack_public_path__ + "static/standard-45022b19619e63ee32878037f060324f.pdf";